import React from "react";
import { MDBContainer, MDBIframe } from "mdbreact";
import { Redirect } from "react-router-dom";
import AppId from "~/utils/partner";
const index = ({ props }) => {
  console.log(props);
  if (AppId === "momo") {
    return (
      <MDBContainer
        style={{ minHeight: "100vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <MDBIframe
          width={414}
          style={{ height: "700px" }}
          src="https://momo-testing.medpro.com.vn"
        />
      </MDBContainer>
    );
  } else {
    return <Redirect to="/" />;
  }
};

export default index;
